import { render } from "./Home.vue?vue&type=template&id=01a01fcc&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=01a01fcc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-01a01fcc"

export default script